import React from 'react';
import PropTypes from 'prop-types';
import ImageProp from '../../../../commonComponents/propTypes/imageProp';

export default function SubHeaderItem({ item, titleClass }) {
  return (
    <span className="session-subheader-item">
      <i className={item.icon} />
      <span className={`session-subheader-item-title ${titleClass}`}>{item.title}</span>
      { item.value &&
        <span className={`session-subheader-item-value ${item.valueClass}`}>
          {item.value}
        </span>
      }
      { item.image &&
        <span className={`session-subheader-item-image ${item.valueClass}`}>
         <img
           className="session-hostTrainer-image"
           src={item.image}
           alt={item.name}
         />
        </span>
      }
    </span>
  );
}

SubHeaderItem.propTypes = {
  item: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    image: PropTypes.oneOfType([
      PropTypes.shape(ImageProp.propType),
      PropTypes.string,
    ]),
    name: PropTypes.string,
    valueClass: PropTypes.string.isRequired,
  }).isRequired,
  titleClass: PropTypes.string,
};

SubHeaderItem.defaultProps = {
  titleClass: '',
};
